import { get, find } from 'lodash';

import * as ICONS from 'constants/icons';
import { INSTANCE_OWNER, INSTANCE_ADMIN } from 'constants/roles';

export const checkPersonScope = (scope, roles) => find(roles, { scope });

export const getPersonIcon = (person) => {
  const roles = get(person, 'data.Roles', []);
  const gender = get(person, 'data.gender') || 'genderless';

  let icon = gender === 'genderless' ? ICONS.GENDERLESS : (gender === 'male' ? ICONS.MALE : ICONS.FEMALE);
  icon = checkPersonScope(INSTANCE_ADMIN, roles) ? ICONS.INSTANCE_ADMIN : icon;
  icon = checkPersonScope(INSTANCE_OWNER, roles) ? ICONS.INSTANCE_OWNER : icon;
  return icon;
};

const personLevel = (gender, roles) => {
  let level = gender;
  // level = maxBy(roles, 'force');

  level = checkPersonScope(INSTANCE_ADMIN, roles) ? INSTANCE_ADMIN : level;
  level = checkPersonScope(INSTANCE_OWNER, roles) ? INSTANCE_OWNER : level;

  return level;
};

export const getPersonItemLevel = (person) => {
  const gender = get(person, 'gender') || 'genderless';
  const roles = get(person, 'Roles', []);

  return personLevel(gender, roles);
};

export const getPersonLevel = (person) => {
  const gender = get(person, 'data.gender') || 'genderless';
  const roles = get(person, 'data.Roles', []);

  return personLevel(gender, roles);
};

export const getPersonSymbol = (person) => {
  const gender = get(person, 'data.gender') || 'genderless';
  return gender === 'genderless' ? ICONS.SYMBOL_GENDERLESS : (gender === 'male' ? ICONS.SYMBOL_MALE : ICONS.SYMBOL_FEMALE);
};

export const getPersonGender = person => get(person, 'data.gender') || 'genderless';
export const getPersonItemGender = person => get(person, 'gender') || 'genderless';

export const getPersonProfilePicture = (person, size = 'large') => {
  const imagesRoot = process.env.IMAGES_ROOT;
  const path = get(person, 'data.ProfilePicture.path') || false;
  const filename = get(person, `data.ProfilePicture.thumbnails.${size}.filename`);
  const url = `${imagesRoot}${path}${filename}`;
  return path ? url : false;
};



// WEBPACK FOOTER //
// ./src/utils/person.js